import { createConsumer } from "@rails/actioncable";
import { BobsWorkspace } from "../stores/BobsWorkspace";

declare global {
  interface Window {
    AccountsSubscription: any;
  }
}

export const startBobAccountsActionCable = (bobsWorkspace: BobsWorkspace) => {
  const consumer = createConsumer();

  window.AccountsSubscription = consumer.subscriptions.create(
    {
      channel: "AccountsChannel",
    },

    {
      connected() {
        // console.log("cable connect in bobs action cable");
        // console.log("will now check if we are going to need 2fa codes");
        bobsWorkspace.selectedBob?.checkIfWeNeedToShowTwoFactorForm();
      },

      disconnected() {
        // Called when the subscription has been terminated by the server
      },
      received(receivedData) {
        console.log(
          "websocket inbound",
          receivedData.message,
          //receivedData.data
        );

        // Cubby

        if (receivedData.message == "bob-balance-update") {
          const bob = bobsWorkspace.getBobByUuid(receivedData.data.uuid);
          bob.updateBalance(
            receivedData.data.safe_balance_in_satoshis,
            receivedData.data.in_flight_satoshis,
          );
        }
        if (receivedData.message == "bob-paid-invoices-update") {
          const bob = bobsWorkspace.getBobByUuid(receivedData.data.uuid);
          bob.setOurInvoices(receivedData.data.invoices);
        }
        if (receivedData.message == "bob-pay-attempts-update") {
          const bob = bobsWorkspace.getBobByUuid(receivedData.data.uuid);
          bob.updatePayAttempts(receivedData.data.pay_attempts, false);
        }
        if (receivedData.message == "bob-hold-invoices-update") {
          // hold_invoices is that vault only; the counts are account-wide
          const bob = bobsWorkspace.bobs.find(
            (b) => b.uuid === receivedData.data.uuid,
          );
          if (bob) bob.setHoldInvoices(receivedData.data.hold_invoices);
          bobsWorkspace.setHoldAccountCounts(
            receivedData.data.open_count_account,
            receivedData.data.accepted_count_account,
          );
        }
        if (receivedData.message == "bob-onchain-inbound-transactions-update") {
          const bob = bobsWorkspace.getBobByUuid(receivedData.data.uuid);
          bob.updateOnchainInboundTransactions(
            receivedData.data.onchain_inbound_transactions,
            receivedData.data.pending_onchain_balance_in_satoshis,
          );
        }
      },
    },
  );
};
